// extracted by mini-css-extract-plugin
export default {"accountButton":"style_accountButton__JELvj","avatar":"style_avatar__mgSte","fullName":"style_fullName__buNLK"};